/**
 * Smooth Scroll Module
 * Because cferdinandi/smooth-scroll assumes too much
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";

const MODULE_NAME = 'core/modules/smooth-scroll';
const log = debug(MODULE_NAME);


//
// Dependencies
import { defaults } from 'lodash';
import smoothScroll from '@vendor/smooth-scroll/smooth-scroll';

//
// Constants
const SCROLL_SELECTOR = 'a[href^="#"]';
const IGNORE_SELECTOR = '[href="#"],[data-no-smooth-scroll]';
const SCROLL_SPEED = 500;
const SMOOTH_SCROLL_OPTIONS = {
	speed: SCROLL_SPEED
};

//
// Cache
let $scrollLinks;

//
// Functions
function handleScrollLinkClick (event) {
	event.preventDefault();

	let $this = $(this),

		// Scroll options - custom for this element
		customOptions = $this.data('options'),

		// Scroll Target
		targetIdSelector = $this.attr('href'),
		$target = $(targetIdSelector);

	if (!$target.length) {
		$target = $(document);
	}

	// Remove focus
	$this.blur();

	// Merge custom options with defaults
	defaults(customOptions, SMOOTH_SCROLL_OPTIONS);

	log('Triggering smooth scroll to', targetIdSelector, 'with options:', customOptions, 'Source:', $this);

	// Trigger smooth scroll
	//noinspection JSUnresolvedFunction
	smoothScroll.animateScroll(targetIdSelector, 0, customOptions);

	// Accessibility - set focus to the target element
	setTimeout(() => {
		let targetElement = $target[0];

		if (!targetElement) {
			return;
		}

		log('Focus target:', targetElement);

		if (targetElement.nodeName === '#document') {
			targetElement.body.focus();
			return;
		}

		targetElement.focus();
	}, SCROLL_SPEED + 1);
}

//
// Exports
export function exec () {
	log('Running...');

	// Fetch links
	$scrollLinks = $(SCROLL_SELECTOR).not(IGNORE_SELECTOR);

	// Bail if not needed
	if (!$scrollLinks.length) {
		log('No internal links found');
	}

	log('$scrollLinks:', $scrollLinks);

	//
	// Bind Handlers
	$scrollLinks.on('click', handleScrollLinkClick);

}





// WEBPACK FOOTER //
// ./client/src/core/modules/smooth-scroll/index.js